module.exports = __webpack_public_path__ + "img/LI.2ea4b2dd.svg";